import type {
	ITimelineEvents,
	ITimelineFormatted,
} from "@/types/timeline-type";

type TimelineBarProps = {
	x: number;
	y: number;
	width: number;
	height: number;
	payload: ITimelineEvents;
	onClick: ({
		value,
		axis,
	}: {
		value?: ITimelineFormatted;
		axis: number;
	}) => void;
};

export const TimelineBar = ({
	x,
	y,
	width,
	payload,
	onClick,
}: TimelineBarProps) => {
	const fullDay = 86400;
	const safeWidth = width > 0 ? width : 290;
	const safeHeight = 16;
	const clipId = `clip-${Math.random().toString(36).slice(2)}`;

	return (
		<g>
			<defs>
				<clipPath id={clipId}>
					<rect
						x={x}
						y={y}
						width={safeWidth}
						height={safeHeight}
						rx={10}
						ry={10}
						onClick={() => onClick({ axis: 0, value: undefined })}
					/>
				</clipPath>
			</defs>

			<rect
				x={x}
				y={y}
				width={safeWidth}
				height={safeHeight}
				rx={10}
				ry={10}
				onClick={() => onClick({ axis: 0, value: undefined })}
				fill="#25B24A"
			/>

			<g clipPath={`url(#${clipId})`}>
				{payload.slots.map((slot, i) => {
					const { startDateSecond, durationSecond } = slot;

					const slotX = x + (startDateSecond / fullDay) * safeWidth;
					const slotWidth = (durationSecond / fullDay) * safeWidth;

					return (
						<rect
							style={{
								zIndex: slot.valueNumber,
							}}
							onClick={() => onClick({ axis: y + 20, value: slot })}
							key={i}
							x={slotX}
							y={y}
							width={slotWidth}
							height={safeHeight}
							fill={slot.color || "#25B24A"}
						/>
					);
				})}
			</g>
		</g>
	);
};

export default TimelineBar;
